import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const Bizum = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.bizum.info" });
};
export {
  Bizum
};
//# sourceMappingURL=Bizum.js.map
